"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoomName = exports.getId = void 0;
const getId = (target, userId) => {
    return target.id ?? userId ?? 'anonymous';
};
exports.getId = getId;
const getRoomName = (target, userId) => {
    return `${target.place}:${target.entity}:${target.scope}:${(0, exports.getId)(target, userId)}`;
};
exports.getRoomName = getRoomName;
